import { theme, media, sunrisePrimitives } from '@vfit/shared/themes';
import { css } from '@emotion/react';
import { ILinkStyledComponent } from './link.models';

const sizes = {
  small: css`
    font-size: ${theme.typography.fontSize.body2};
  `,
  big: css`
    font-size: ${theme.typography.fontSize.body1};
  `,
  responsive: css`
    font-size: ${theme.typography.fontSize.body3};
    ${media.desktop`
      font-size: ${theme.typography.fontSize.body2};
    `}
  `,
  responsiveMedium: css`
    font-size: ${theme.typography.fontSize.body1};
  `,
  responsiveBig: css`
    font-size: ${theme.typography.fontSize.body3};
    ${media.desktop`
      font-size: ${theme.typography.fontSize.body1};
    `}
  `,
};

const transition = css`
  transition: color 0.3s ease;

  & svg * {
    transition: stroke 0.3s ease, fill 0.3s ease;
  }
`;

const variants = {
  regular: css`
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.colors.text.primary};
    ${transition}

    &:hover {
      color: ${theme.colors.brand.primaryHover};
    }
  `,
  breadcrumb: css`
    color: ${theme.colors.text.primary};
    ${transition};

    &:hover {
      color: ${theme.colors.brand.primaryHover};
    }
  `,
  white: css`
    color: ${theme.colors.text.inverse};
  `,
  'mva:turquoise': css`
    color: ${sunrisePrimitives.cyan};
    text-decoration: underline;
    text-underline-offset: 4px;
  `,
};

export const common = (props: ILinkStyledComponent) => css`
  ${sizes[props.size || 'small']}
  align-items: center;
  display: inline-flex;
  gap: ${theme.spacing.sm};
  line-height: inherit;
  ${variants[props.variant || 'regular']}

  &::selection {
    background-color: transparent;
  }
`;

// cursor: not-allowed; is ignored because pointer-events: none;
// but pointer-events: none; is necessary to disable Link from Next
export const disabled = css`
  color: ${theme.colors.text.secondary};
  cursor: not-allowed;
  pointer-events: none;
  text-decoration: none;
`;